import React, { useState, useEffect } from 'react';
import { Grid, Input, Divider, Button } from 'semantic-ui-react';

const mapper = {
  celsius: 1,
  fahrenheit: (f) => (f - 32) * (5 / 9),
};

// value should be in celsius. onUpdated will be passed value in celsius too.
function Temperature({ value, onUpdated }) {
  const currentValue = parseFloat(value?.value || 0);
  const [type, setType] = useState('celsius');
  const [val, setVal] = useState(currentValue);
  const [label, setLabel] = useState('°C');

  useEffect(() => {
    if (type === 'celsius') {
      setLabel('°C');
      onUpdated(val);
    }
    if (type === 'fahrenheit') {
      setLabel('°F');
      onUpdated(mapper.fahrenheit(val));
    }
  // eslint-disable-next-line
  }, [type, val]);

  const processChange = (inVal, inSubVal) => {
    setVal(parseFloat(inVal || val || 0));
  }

  return (
    <>
      <Button.Group>
        <Button toggle active={type === 'celsius'} onClick={() => setType('celsius')}>Celsius</Button>
        <Button toggle active={type === 'fahrenheit'} onClick={() => setType('fahrenheit')}>Fahrenheit</Button>
      </Button.Group>
      <Divider hidden />

      <Grid stackable>
        <Grid.Column width={8}>
          <Input fluid value={val} onChange={e => processChange(e.target.value)} 
            label={{ basic: true, content: label }}
            labelPosition='right'
          />
        </Grid.Column>
      </Grid>
    </>
  );
}

export default Temperature;
